import 'pages/frontend/rightToLeft/_rightToLeft.scss'
import { Route, Routes } from 'react-router-dom'
import About from './About'
import Hero from './Hero'
import Skills from './Skills'
import Services from './Services'
import Contact from './Contact'
import Portfolio from './Portfolio'

export default function index() {
    return (
        <>
            {/* here we have some inner routes in which i have different pages like "about","skills" etc. You can add pages if you want to add more  */}
            {/* and i add an "_rightToLeft.scss" file and I just add one scss file where you can change the stylling and colors of all these components*/}
            <Routes>
                <Route path='home' element={<Hero />} />
                <Route path='about' element={<About />} />
                <Route path='skills' element={<Skills />} />
                <Route path='services' element={<Services />} />
                <Route path='portfolio' element={<Portfolio />} />
                <Route path='contact' element={<Contact />} />
            </Routes>
        </>
    )
}
